import { selfCheckInRoute } from 'src/apis';
export const selfCheckInByMagicTokenRoute = `${selfCheckInRoute}/magic?`;
